import { render } from "./PopupConfirmationGuest.vue?vue&type=template&id=4f631c79&scoped=true"
import script from "./PopupConfirmationGuest.vue?vue&type=script&lang=js"
export * from "./PopupConfirmationGuest.vue?vue&type=script&lang=js"

import "./PopupConfirmationGuest.vue?vue&type=style&index=0&id=4f631c79&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f631c79"]])

export default __exports__